const firebaseConfig = {
  apiKey: "AIzaSyDBZld--2di_fadmLCGpT8mwtwj-TJjmek",
  authDomain: "travely-217e4.firebaseapp.com",
  projectId: "travely-217e4",
  storageBucket: "travely-217e4.appspot.com",
  messagingSenderId: "471083433358",
  appId: "1:471083433358:web:239132342bc19d9e5cf8df",
};
export default firebaseConfig;
